function safeParse(json, def) {
    try {
        return JSON.parse(json);
    } catch {
        return def;
    }
}

function makePostContext(appContext, postElement) {
    return appContext
        .getUserInfo()
        .then((userInfo) => {
            return userInfo.runnerSite.permissions;
        })
        .catch((err) => {
            console.log(err);
            return {};
        })
        .then((permissions) => {
            const sectionIdElement = postElement.closest("[data-section-id]");
            const sectionId = sectionIdElement
                ? parseInt(sectionIdElement.dataset.sectionId, 10)
                : null;

            const sourceElement = postElement.closest("[data-source]");
            const source = sourceElement ? sourceElement.dataset.source : null;
            const frozenSections = safeParse(postElement.dataset.frozenSections, []);

            return {
                appContext,
                postElement,
                sectionId,
                source,
                permissions: permissions,
                postId: postElement.getAttribute("elid") || postElement.dataset.userPrefs,
                isFrozen: frozenSections.includes(sectionId),
            };
        });
}

export default makePostContext;

export const __PRIVATE__ = {
    makePostContext,
};
